import * as CryptoJS from 'crypto-js';
import { TypeEnum } from '../models/template/type.enum';

export class Helper {
  ///todo :: @dominik provjeriti ovo ,ako postoji ograničenje u responsysu onda napraviti validaciju
  //na input polju i javiti korisniku u kojem formatu je dozvoljeno unositi template name
  static removeSpecialCharacters(str: string, type?: TypeEnum): string {
    str = str.trim();
    if (type === TypeEnum.WHATSAPP) {
      str = str.toLowerCase();
    }
    return str.replace(/[^a-zA-Z0-9_]/g, '');
  }

  // Normalize a field value for duplicate-text comparison: strip HTML tags,
  // remove all punctuation/symbols, collapse whitespace/indentation, uppercase.
  static normalizeForComparison(value: string): string {
    return (value ?? '')
      .replace(/<[^>]*>/g, ' ')            // strip any HTML tags (safety; RSA fields are plain text)
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')   // strip ALL punctuation/symbols, keep letters/numbers/space
      .replace(/\s+/g, ' ')                // collapse whitespace + indentation
      .trim()
      .toUpperCase();
  }

  static extracLinkFromHtml(htmlString?: string) {
    const anchorRegex = /<a[^>]*href=["']([^"']*)["'][^>]*>/i;
    const match = htmlString?.match(anchorRegex);
    if (match && match[1]) {
      const imageUrl = match[1]; // Extracted URL from href
      return `${imageUrl}`;
    }
    return htmlString ? htmlString : ''; // Return empty string if no m
  }

  static generateIdHash(input: string): string {
    //return input;
    // Generate SHA256 hash using CryptoJS
    const hash = CryptoJS.SHA256(input);

    // Convert the hash to Base64 (same as .NET Convert.ToBase64String)
    let idHash = this.removeSpecialCharacters(hash.toString(CryptoJS.enc.Base64));
    // console.log("This is Input: " + input);
    // console.log("This is Template ID: " + idHash);
    return idHash;
  }

  static makeTimestampedId() {
    const ts = Date.now().toString(36); // timestamp in base-36
    const rand = Math.random().toString(36).substr(2, 5);
    return `${ts}-${rand}`;
  }

  static getFullUrl(url: string | undefined): string {
    return url && url.startsWith('http') ? url : `https://${url}`;
  }

  static isEmpty(obj: object) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true
  }

  static convertToStandard(col: string): string {
    if (!col) return '';
    // Pretvori camelCase/PascalCase u riječi s razmakom
    let result = col
      // Razdvoji kad slijedi veliko slovo iza malog slova ili broja
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      // Razdvoji kad slijedi veliko slovo iza prethodnog velikog slova i malog slova
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      // Početno veliko slovo
      .replace(/^./, first => first.toUpperCase());

    return result;
  }
}
